import _ from 'underscore';

export default (hotelOffer: any): any => ({
        ..._.pick(hotelOffer,
            'cancellationPolicy',
            'price',
            'discount',
            'medicalInsurance',
            'firstPaymentDefinitions',
            'checkInDate',
            'id',
            'meal',
            'departureCity',
            'country',
            'resort',
            'hotel',
            'cashbackAvailable',
            'operator',
            'price',
            'room',
            'touristGroup',
            'hotelAvailable',
            'nights'),
        type: 'HotelOfferProduct',
        originalPrice: hotelOffer.maxHistoricalPrice,
    });